import { Checkbox, CheckboxChangeEvent, Flex } from 'antd'
import { FC, useContext } from 'react'
import Shipment from '../../../../../types/api/shipment'
import { JobStatuses } from '../../../../../types/api/print-job'
import { ShipmentsPageCtx } from '../../../shipments-page'
import { isShipmentCalculatedOnActual } from '../../../../../helpers/entities/shipment/get-shipment-display-calculated'

interface ShipmentDealCellProps {
    checked?: boolean
    record: Shipment
}

const ShipmentDealCell: FC<ShipmentDealCellProps> = ({ checked, record }) => {
    const { onUpdateShipmentProperty } = useContext(ShipmentsPageCtx)
    const isColorProof = record.shipmentType === 'colorProof'
    const isEditable =
        !isColorProof && record.print_job?.jobStatus === JobStatuses.Completed && isShipmentCalculatedOnActual(record)

    const handleChange = (e: CheckboxChangeEvent) => {
        onUpdateShipmentProperty(record, ['deal', e.target.checked])
    }

    return (
        <Flex justify={'center'}>
            <Checkbox
                checked={!isColorProof && checked}
                disabled={!isEditable}
                onChange={handleChange}
            />
        </Flex>
    )
}

export default ShipmentDealCell
